/* eslint-disable react/no-this-in-sfc */
import React from 'react';
import { EmptyState } from '../../../CommonComponents/OPL/AsyncStates/EmptyState/EmptyState';
import { ErrorState } from '../../../CommonComponents/OPL/AsyncStates/ErrorState/ErrorState';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { AreaSplineChartLoading } from '../../../CommonComponents/OPL/charts/AreaSplineChart/AreaSplineChart.loading';
import { useAmountInvestedChart } from '../../hooks/useAmountInvestedChart';
import { ValueVsInvestmentChartContent } from './components/ValueVsInvestmentChartContent/ValueVsInvestmentChartContent';

interface ValueVsInvestmentChartProps {
  title: string;
  portfolioReturn: number | null;
  updatedAt: string;
}

export const ValueVsInvestmentChart = ({
  title,
  portfolioReturn,
  updatedAt,
}: ValueVsInvestmentChartProps) => {
  const { isFetching, isError, refetch, data } = useAmountInvestedChart();

  if (isFetching) {
    return <AreaSplineChartLoading containerProps={{ style: { height: 'unset' } }} />;
  }

  if (isError) {
    return (
      <Box display="flex" alignItems="center" justifyContent="center" height="100%">
        <ErrorState onAction={refetch} />
      </Box>
    );
  }

  if (!data) {
    return null;
  }

  if (data.length === 0) {
    return (
      <Box height="100%" display="flex" alignItems="center" justifyContent="center">
        <EmptyState />
      </Box>
    );
  }

  return (
    <ValueVsInvestmentChartContent
      data={data}
      portfolioReturn={portfolioReturn}
      title={title}
      updatedAt={updatedAt}
    />
  );
};
